export default __webpack_public_path__ + "static/property-no-image-72e1eaf7f7d28d2b3304c09f388cc29c.png";